export interface IAddress {
  city?: string;
  countryName?: string;
  placeName?: string;
  street?: string;
  zip?: string;
  name?: string;
  description?: string;
  countryDisplayName?: string;
}
